export const LoginActionTypes = {
    LOGIN_FIRST: '@@auth/LOGIN_FIRST',
    LOGIN_LOADING: '@@auth/LOGIN_LOADING',
    LOGIN_SUCCESS: '@@auth/LOGIN_SUCCESS',
    LOGIN_ERROR: '@@auth/LOGIN_ERROR',
    LOGIN_RESET: '@@auth/LOGIN_RESET',
};
